export const AUTH_WIDGET_ID = "auth-widget";
